import React, { useEffect, useRef, useState } from 'react';
import apiUrl from '@common/utils/apiURL';
import useApi from '@common/utils/useApi';
import { Link } from 'react-router-dom'
import Details from './components/Details'
import ProfileMenu from '@common/components/ProfileMenu';


function Profile() {
    const [profileData, setProfileData] = useState([]);
    const getProfileURL = apiUrl.profile.getProfile;
    
    const { data: responseProfileData, loading: isLoadingProfileData, errorProfileData } = useApi(getProfileURL);
    useEffect(() => {
        // console.log('responseAllTimeFav', isLoadingAllTimeFav, responseAllTimeFav, cartData);
        if (!isLoadingProfileData && responseProfileData) {
            setProfileData(responseProfileData?.data);
            localStorage.setItem('u_info', JSON.stringify(responseProfileData?.data));
        }
    }, [isLoadingProfileData, responseProfileData]);

  return (
    <div className='bs-section'>
        <div className='lyt-profile'>
            <div className='lyt-profile__header'>
                <Link className='lyt-profile__title'>
                    <span className='icon icon-o-left lyt-profile__title-icon'></span>
                    <span className='lyt-profile__title-text'>your profile</span>
                </Link>
            </div>
            <div className='lyt-profile__body'>
                <ProfileMenu data={profileData} />
                <div className='lyt-profile__cont-wrap'>
                    <Details data={profileData} setProfileData={setProfileData} />
                </div>
            </div>
        </div>
    </div>
  )
}

export default Profile